document.addEventListener('DOMContentLoaded', () => {

    const mediaMaxChapterFixed = window.matchMedia('(min-width: 1200px)');
    const overlow = document.querySelector('.overlow');
    const body = document.querySelector('body');

    let scrollWidth = window.innerWidth;
    const windowWidth = window.innerWidth;

    if ('scrollWidth' in document.body) {
        scrollWidth = document.body.scrollWidth; // width scroll
    }

    const totalScrollWidth = windowWidth - scrollWidth;
    let scrollDocument = '';

    function overlowShow() {
        if (mediaMaxChapterFixed.matches) {
            body.style.paddingRight = `${totalScrollWidth}px`;
            if (scrollDocument !== '') scrollDocument.style.paddingRight = `${totalScrollWidth}px`;
        }
        body.style.overflow = 'hidden';
        overlow.classList.add('overlow--active');
    }

    function overlowHide() {
        overlow.classList.remove('overlow--active');
        body.style.paddingRight = '';
        body.style.overflow = '';
        if (scrollDocument !== '') scrollDocument.style.paddingRight = '';
    }








    // begin УНИВЕРСАЛЬНЫЙ скрипт для модальных окон
    /* 
        1. Модальному окну надо написать data-modal="number" (добавить класс modalWindow);
        2. Модальному окну ко второму родителю (добавить класс modalOverlow):
        3. Кнопке по которуму будет открываться модальное окно написать data-modalBtn="number" (добавить класс modalBtn);
        4. Закрытие модального окна на нажатию крестик data-close="number" (добавить класс modalClose);
    */
    function uneversalModal() {
        const modalBtn = document.querySelectorAll('.modalBtn');
        const modalWindow = document.querySelectorAll('.modalWindow');
        const modalClose = document.querySelectorAll('.modalClose');

    
        for (let i = 0; i < modalBtn.length; i++) {
            modalBtn[i].addEventListener('click', (e) => {
                e.preventDefault();
                const dataModalBtn = +modalBtn[i].dataset.modalbtn;
                modalWindow.forEach(element => {
                    const dataModal = +element.dataset.modal;
                    if (dataModalBtn === dataModal) {
                        element.classList.add('show');
                        overlowShow();
                        overlow.setAttribute('data-overlow', `${dataModal}`);
                    }
                });
            });
        }

        for (let i = 0; i < modalClose.length; i++) {
            modalClose[i].addEventListener('click', () => {
                const dataClose = +modalClose[i].dataset.close;
                modalWindow.forEach(element => {
                    const dataModal = +element.dataset.modal;
                    if (dataClose === dataModal) {
                        element.classList.remove('show');
                        overlowHide();
                        overlow.setAttribute('data-overlow', `${dataModal}`);
                    }
                });
            });
        }

        for (let i = 0; i < modalWindow.length; i++) {
            modalWindow[i].addEventListener('click', (e) => {
                if ((e.target !== modalWindow[i]) && 
                    (e.target !== modalWindow[i].querySelector('.modalOverlow')) &&
                    e.target !== modalWindow[i].querySelector('.reviewspage__form-wrapper')) {
                    return;
                }
                modalWindow[i].classList.remove('show');
                overlowHide();
            });
        }

        document.addEventListener('keydown', (e) => {
            modalWindow.forEach(el => {
                if (el.classList.contains('show')) {
                    if (e.keyCode === 27) el.classList.remove('show');
                }
            });
        });
    }
    uneversalModal();
    // end УНИВЕРСАЛЬНЫЙ скрипт для модальных окон







    

    // begin Секция Наши доставки
    // Массив объектов карточек
    const news = [
        {
            'image' : '7',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Федеральная дорога М-12 Уфа - Казань',
            'linkstext' : [
                'КС 15.6 (бетон В25, F2 300, W8) серия 3.900.1-14',
                'ПП 15-1 (бетон В25, F2 300, W8) серия 3.900.1-14',
                'КС 15.6 (бетон В25, F2 300, W8) серия 3.900.1-14',
                'КС 7.9 (бетон В25, F2 300, W8) серия 3.900.1-14',
                'ОП-1д (бетон В25, F2 300, W8) серия 3.900.1-14',
                'Кольцо стеновое КС 13-9(B35 F2300 W12)',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-15-6.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/krishki-kolodtsev-pp/pp-15-1.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-15-6.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-7-9.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolodtsi/opornie-pliti-op/op-1d.html',
                '',
            ],
            'description' : 'Наша компания, специализирующаяся на продаже железобетонных изделий под ключ, завершила реализацию проекта по поставке  материалов для строительства федеральной дороги Уфа-Казань. Все изделия были доставлены в полной комплектации и в соответствии с графиком – это является ярким примером нашей способности эффективно удовлетворять потребности в самых требовательных проектах.',
            'smalltext' : 'Не ждите повышения цен, покупайте сейчас!',
        },

        {
            'image' : '8',
            'facility' : 'Объект',
            'date' : 2020,
            'title' : 'Инновационный центр Сколково, г. Москва',
            'linkstext' : [
                'ВГ-15',
                'ПП 15-2',
                'КС 15-9',
                'ВП 34-12',
                'ДБ-54',
                'Люк тип «ТМ» (Д400) 2-60 ОУЭ-600',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolodtsi/kolodci-vodoprovodno-gazovie/vg-15.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/krishki-kolodtsev-pp/pp-15-2.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-15-9.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/teplovie-seti/pliti-vp/vp-34-12.html',
                'https://dsk-stolica.ru/jilischnoe-stroitelstvo/zhelezobetonnie-balki/balki-alqabom-ps-192/db-54.html',
                '',
            ],
            'description' : 'Наши клиенты могут всегда рассчитывать на своевременную и надежную доставку строительных материалов. Недавно наша команда успешно завершила поставку высококачественных строительных изделий для нового проекта. Благодаря точной координации действий всех участников процесса и использованию современных логистических решений, доставка была выполнена в кратчайшие сроки. Мы продолжаем подтверждать свою репутацию надежного партнера в сфере строительства.',
            'smalltext' : 'У нас самые квалифицированные специалисты!',
        },

        {
            'image' : '9',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Квартал ЗИЛ наружние сети, г. Москва',
            'linkstext' : [
                'ВП 43-12 усил. (сетка 120 кг)',
                'ВП-43-18инд./отв.в центре',
                'Плита канальная',
                'V-2.65 P-6.62 4300х1800х360',
                'Дорожные плиты 2П 30.18-30 ТУ',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/teplovie-seti/pliti-vp/vp-43-12.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/teplovie-seti/pliti-vp/vp-43-18-s-centralnim-otverstiem.html',
                '',
                '',
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/dorozhnie-pliti',
            ],
            'description' : 'Компания ДСК-Столица успешно осуществила поставку строительных компонентов для модернизации промышленного предприятия. Благодаря использованию собственной транспортной инфраструктуры, мы обеспечили точное выполнение графика и минимизацию рисков. Мы ценим доверие наших партнеров и стремимся поддерживать высокие стандарты качества и надежности во всех наших поставках.',
            'smalltext' : 'Товары по ГОСТ, доставка до объекта!',
        },

        {
            'image' : '10',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Электроподстанция для высокоскоростной трассы Москва - Санкт- Петербург',
            'linkstext' : [
                'П 10.5 (995х495х60)',
                'Серия 3.407.1-157',
                'БМ-9 серия ППВКН32',
                'Балка железобетонная',
                'V-0,38 Р-0,95 2500х500х300',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/lotki-zhelezobetonnie/pliti-lotkov-p/p-10-5.html',
                '',
                'https://dsk-stolica.ru/jilischnoe-stroitelstvo/zhelezobetonnie-balki/balki-seriya-pp-vkn-32/bm-9.html',
                '',
                '',
            ],
            'description' : 'Компания ДСК-Столица завершила поставку строительных материалов для нового крупного проекта. Благодаря четкому планированию и профессиональному подходу, мы смогли выполнить поставку в срок и удовлетворить все потребности наших клиентов. Мы гордимся достигнутыми результатами и благодарим своих клиентов за доверие.',
            'smalltext' : 'Быстрый заказ!',
        },

        {
            'image' : '11',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Строительство дороги М12, Нижегородская область',
            'linkstext' : [
                'КС 15-9',
                'ПП 15-2',
                'ПД-15',
                'КС 13-9',
                'КС 13-6',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-15-9.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/krishki-kolodtsev-pp/pp-15-2.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/pliti-dnischa/pd-15-plita-dnishha.html',
                '',
                '',
            ],
            'description' : 'Одним из наших недавних достижений стала доставка комплексной партии строительных материалов для строительства трассы в Нижегородской области. Мы используем передовые технологии для отслеживания и управления процессом доставки, что позволяет нам минимизировать риски и обеспечивать надежность нашего сервиса. Мы гордимся нашими высокими стандартами качества и стремимся к долгосрочному сотрудничеству с застройщиками и инвесторами.',
            'smalltext' : 'Экспресс-расчет вашего проекта!',
        },

        {
            'image' : '12',
            'facility' : 'Объект',
            'date' : 2022,
            'title' : 'Развязка МКАД и М-4 г. Москва',
            'linkstext' : [
                'МШЛ-0.7д',
                'БР 100.30.18',
                'БР 100.20.8',
                'Фундаменты Ф-3',
            ],
            'links' : [
                'https://dsk-stolica.ru/zheleznodorozhnoe-stroitelstvo/drenazhnie-lotki/lotki-mshl/mshl-0-7.html',
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/bordyur-trotuarnii/bortovoi-kamen-br/br-100-30-18.html',
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/bordyur-trotuarnii/bortovoi-kamen-br/br-100-20-8.html',
                'https://dsk-stolica.ru/chastnoe-domostroenie/fundamentnie-bloki',
            ],
            'description' : 'Мы успешно доставили партию высококачественных строительных изделий на новый дорожно-транспортный проект в городе Москве. Благодаря слаженной работе наших логистов и водителей, все грузы прибыли на объект без повреждений и вовремя. Мы ценим доверие наших клиентов – уверены, что следующий вызов уже на подходе, и мы готовы к новым достижениям вместе с нашими партнерами.',
            'smalltext' : 'Быстрый расчёт заявки! Хотите так же? Обращайтесь!',
        },

        {
            'image' : '13',
            'facility' : 'Объект',
            'date' : 2019,
            'title' : 'ОЗОН, Московская область, городской округ Солнечногорск',
            'linkstext' : [
                '1ПП-1',
                'ЛС-14',
                'ЛМ-1',
                'ПБ 60.12-8',
            ],
            'links' : [
                '',
                '',
                '',
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pb/pb-60-12-8.html',
            ],
            'description' : 'Заказчики всегда могут полагаться на нашу компанию ДСК-Столица в плане доставки строительных материалов. В данном проекте мы успешно организовали доставку железобетонных изделий на строительную площадку нового склада ОЗОН в Солнечногорске. Наша команда разработала эффективный маршрут и обеспечила доставку вовремя. Благодарим наших партнеров за доверие и готовность сотрудничать в будущих проектах.',
            'smalltext' : 'Не ждите повышения цен, покупайте сейчас!',
        },

        {
            'image' : '14',
            'facility' : 'Объект',
            'date' : 2017,
            'title' : 'Ярославский вокзал/Круговое депо Ярославского вокзала',
            'linkstext' : [
                'ПБ 60-12-12',
                'ПБ 60-10-12',
                'Брусчатка бр200*100*60 серая и черная',
                'Плитка тактильная 50*50*5',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pb/pb-60-12-12.html',
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pb/pb-60-10-12.html',
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/dorozhnoe-pokritie/bruschatka-edd',
                '',
            ],
            'description' : 'Недавно наша компания успешно осуществила поставку строительных материалов для крупного строительного проекта в Москве. Мы справились с задачей в рекордные сроки, обеспечили высокое качество продукции и соблюдение всех технических требований. ДСК-Столица продолжает укреплять свою репутацию надежного партнера в сфере строительства.',
            'smalltext' : 'Моментальный расчёт заказа! Хотите узнать больше? Свяжитесь с нами!',
        },

        {
            'image' : '15',
            'facility' : 'Объект',
            'date' : 2020,
            'title' : 'Кинопарк "Москино", Москва, Красная пахра',
            'linkstext' : [
                'Кольца для колодца',
                'Плиты перекрытия',
                'Аэродромные плиты ПАГ',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca',
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya',
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/aerodromnie-pliti/pliti-pag',
            ],
            'description' : 'Компания ДСК-Столица организовала поставку строительных материалов для строительства кинопарка «Москино» в Красной Пахре. Гибкий подход и строгий контроль позволили нам минимизировать время доставки и обеспечить сохранность всех поставленных компонентов. Благодарим вас за оказанное доверие и готовность сотрудничать с нами.',
            'smalltext' : 'Товары по ГОСТ, доставка до объекта!',
        },

        {
            'image' : '16',
            'facility' : 'Объект',
            'date' : 2021,
            'title' : 'Восточный вокзал Черкизово, г. Москва',
            'linkstext' : [
                'Лотки железнодорожные МПЛ-0,75',
                'Лотки железнодорожные МПЛ-1,0',
                'Крышки КР-3',
            ],
            'links' : [
                '',
                '',
                'https://dsk-stolica.ru/zheleznodorozhnoe-stroitelstvo/drenazhnie-lotki/krishki-lotkov/kr-3-krishka-lotka.html',
            ],
            'description' : 'Поступил заказ от организации на поставку строительных материалов для крупного проекта. Компания ДСК-Столица оперативно откликнулась и осуществила поставку железобетонных изделий для возведения нового вокзала в городе Москве. Партия материалов была доставлена точно в срок и полностью соответствовала всем требованиям заказчика. В процессе реализации проекта мы использовали современную логистическую инфраструктуру и новейшие технологии, позволившие нам оперативно решать возникающие задачи и поддерживать высокие стандарты обслуживания.',
            'smalltext' : 'Быстрый заказ!',
        },

        {
            'image' : '17',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Трасса Любытино-Неболчи-Бокситогорск',
            'linkstext' : [
                'Блок экрана Ф3',
                'Блок Ф2 л/п 10-205',
                'Блок Ф1 л/п 10-130',
            ],
            'links' : [
                '',
                '',
                '',
            ],
            'description' : 'Компания ДСК-Столица организовала поставку строительных материалов для нового крупного проекта. Наша команда специалистов разработала и реализовала эффективную логистическую стратегию – она включала в себя точное планирование маршрутов и использование современного транспортного оборудования.Этот проект стал ярким примером нашей способности эффективно удовлетворять потребности наших клиентов и успешно справляться с самыми сложными логистическими задачами в строительной индустрии.',
            'smalltext' : 'Сделайте заказ прямо сейчас!',
        },

        {
            'image' : '18',
            'facility' : 'Объект',
            'date' : 2022,
            'title' : 'Тимирязевская СХА/ЖК Проспект 39, г. Москва',
            'linkstext' : [
                'Лотки железобетонные ЛК',
                'Кольца КС',
                'Колодцы ВГ, ККС',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/lotki-zhelezobetonnie/lotki-lk',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolodtsi/kolodci-telefonnie-kks',
            ],
            'description' : 'Компания ДСК-Столица завершила доставку строительных материалов для элитного жилого комплекса на Тимирязевской. Все поставки были выполнены с точностью до минуты, благодаря чему строительство идет по графику и без задержек. Наша компания использует только современную логистическую систему, гарантирующую надежность и высокое качество каждой поставки. Мы гордимся тем, что вносим свой вклад в создание важных объектов инфраструктуры для нашего города.',
            'smalltext' : 'Быстрый заказ!',
        },

        {
            'image' : '19',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'ЖК ПАРКСАЙД/ ЖК Петровский Парк-2, г. Москва',
            'linkstext' : [
                'Лестничные марши',
                'Коллекторы',
                'Канализационные люки',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/lestnichnie-marshi',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kollektori',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kanalizatsionnie-lyuki',
            ],
            'description' : 'Наш последний проект по доставке строительных материалов на объект в городе Москве был выполнен с наилучшими результатами – все материалы были доставлены в соответствии с графиком. Заказчик отметил высокий уровень профессионализма нашей команды и выразил благодарность за проделанную качественную работу.',
            'smalltext' : 'Товары по ГОСТ, доставка до объекта!',
        },

        {
            'image' : '20',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Театр "Оперы и Балета" г. Севастополь',
            'linkstext' : [
                'Противовес PHZ 5600',
                'Противовес PHZ 5500A',
                'Противовес PHZ 4500',
            ],
            'links' : [
                '',
                '',
                '',
            ],
            'description' : 'Компания ДСК-Столица вновь продемонстрировала свои высокие стандарты качества и оперативности. Недавно наша команда завершила поставку железобетонных изделий на строительную площадку нового театра «Оперы и Балета» в городе Севастопль. Несмотря на сложные погодные условия и загруженность дорог, наша команда смогла выполнить все обязательства перед заказчиком – мы доставили материалы в полном объеме и без повреждений. Мы продолжаем придерживаться высоких стандартов обслуживания и благодарим заказчика за выбор нашей компании.',
            'smalltext' : 'Товары по ГОСТ, доставка до объекта!',
        },

        {
            'image' : '21',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'СК Олимпийский, г. Москва',
            'linkstext' : [
                'Кольца КС 10-9',
                'Кольца КС 7-6',
                'ПТО 300.150.14',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-10-9.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks/ks-7-6.html',
                '',
            ],
            'description' : 'Клиент обратился в ДСК-Столица с запросом о поставке строительных материалов для строительства нового спортивного комплекса Олимпийский. Наши специалисты организовали качественную и эффективную логистику доставки: подобрали оптимальный маршрут и транспортные средства для обеспечения своевременности поставок. Благодаря нашему опыту и профессионализму, мы уверены в положительном результате нашего сотрудничества и готовы к долгосрочному партнерству с клиентом.',
            'smalltext' : 'Не упустите возможность получить бесплатную консультацию!',
        },

        {
            'image' : '22',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Распределительный центр Пахра, Московская область, Домодедово',
            'linkstext' : [
                'Лоток Л3-15/2',
                'Плита П6-15б',
                'ОП8',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/lotki-zhelezobetonnie/lotki-l/l-3-15-2.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/lotki-zhelezobetonnie/pliti-lotkov-p/p-6-15b.html',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/lotki-zhelezobetonnie/opornie-podushki-op/op-8.html',
            ],
            'description' : 'Мы гордимся нашей способностью обеспечивать своевременную и эффективную доставку строительных материалов. Благодаря нашей команде профессионалов и современной логистической сети мы уверены в качестве и надежности наших услуг. В последнем проекте мы успешно доставили необходимые изделия на строительную площадку за рекордно короткий срок. Наши клиенты могут быть уверены в качестве и надежности наших услуг на каждом этапе сотрудничества.',
            'smalltext' : 'У нас самые квалифицированные специалисты!',
        },

        {
            'image' : '23',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Строительство свиноводческой фермы, Кашин Тверская область',
            'linkstext' : [
                'ПБ 63-12-8',
                'ПБ 57-12-8',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pb/pb-63-12-8.html',
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pb/pb-57-12-8.html',
            ],
            'description' : 'Клиент обратился в нашу компанию с запросом на поставку крупной партии железобетонных изделий для строительства свиноводческой фермы в Тверской области. Наша компания успешно организовала и завершила доставку материалов с соблюдениями всех сроков и с учетом требований заказчика. Процесс поставки контролировался на всех этапах, чтобы мы могли гарантировать высокое качество и сохранность изделий. Наша команда всегда готова предложить лучшие решения для строительных проектов наших клиентов и стремится к успешному сотрудничеству в будущем.',
            'smalltext' : 'овары по ГОСТ, доставка до объекта!',
        },

        {
            'image' : '24',
            'facility' : 'Объект',
            'date' : 2017,
            'title' : 'аэропорт Шереметьево имени А.С. Пушкина, г. Москва',
            'linkstext' : [
                'Лотки железобетонные ЛК',
                'Дорожные плиты',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/lotki-zhelezobetonnie/lotki-lk',
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/dorozhnie-pliti',
            ],
            'description' : 'Наша компания гордится своей репутацией надежного поставщика строительных материалов. На прошлой неделе мы успешно осуществили доставку крупной партии строительных изделий. Наша логистическая служба обеспечила точную и своевременную доставку всех необходимых материалов, благодаря чему монтажные работы начались без каких-либо задержек. Заказчик выразил благодарность нашей команде за высокий уровень обслуживания.',
            'smalltext' : 'Сделайте заказ прямо сейчас!',
        },

        {
            'image' : '25',
            'facility' : 'Объект',
            'date' : 2018,
            'title' : 'Трамвайное депо, г. Москва,Шаболовская',
            'linkstext' : [
                'Газоблоки',
                'Кольца КС',
            ],
            'links' : [
                '',
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks',
            ],
            'description' : 'Мы завершили важный проект по доставке изделий для строительства трамвайного депо в Москве. Все материалы прибыли на стройплощадку без задержек и повреждений, что позволило нашему клиенту начать работы в запланированные сроки. Клиент остался доволен оперативностью и качеством наших услуг.',
            'smalltext' : 'Быстрый заказ!',
        },

        {
            'image' : '26',
            'facility' : 'Объект',
            'date' : 2016,
            'title' : 'Дата центр Яндекс, г. Владимир',
            'linkstext' : [
                'ПК 27-12-8',
                'Перемычки 8ПБ 10-1',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pk/pk-27-12-8.html',
                'https://dsk-stolica.ru/chastnoe-domostroenie/peremichki-zhelezobetonnie/peremichki-bruskovie/8pb-10-1p.html',
            ],
            'description' : 'Компания ДСК-Столица рада сообщить об успешной доставке строительных материалов на строительную площадку дата-центра Яндекс в городе Владимире. Наша команда профессионалов гарантирует своевременные поставки и строгий контроль качества на каждом этапе. Благодарим всех сотрудников за отличную работу и продолжим радовать наших клиентов безупречным сервисом.',
            'smalltext' : 'Рассчитаем стоимость вашего проекта быстро и эффективно!',
        },

        {
            'image' : '27',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'ЖК "Вдохновение", г. Рязань',
            'linkstext' : [
                'Блоквентиляционный БВ-1.1 (750х700х3290)',
                'Блоквентиляционный БВ-2.1 (550х300х3290)',
            ],
            'links' : [
                '',
                '',
            ],
            'description' : 'Компания ДСК-Столица, специализирующаяся на продаже железобетонных изделий, рада сообщить о нашем последнем успешном проекте по поставке продукции для строительства нового жилищного комплекса «Вдохновение» в городе Рязани. Мы обеспечили поставку полного ассортимента железобетонных изделий, все материалы были доставлены на строительную площадку строго в соответствии с графиком. Каждый этап доставки был тщательно спланирован и реализован нашими опытными специалистами. Выбирая нашу компанию, вы выбираете качество, оперативность и индивидуальный подход. Мы продолжаем развиваться и стремимся к новым успехам в области поставок изделий для самых разнообразных проектов.',
            'smalltext' : 'Не ждите повышения цен, покупайте сейчас!',
        },

        {
            'image' : '28',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'ЖК «ДЫШИ», г. Тула',
            'linkstext' : [
                'Блоквентиляционный БВ-3.2 (450х300х3290)',
                'Блоквентиляционный БВ-4.1 (450х300х3290)',
            ],
            'links' : [
                '',
                '',
            ],
            'description' : 'Компания ДСК-Столица успешно выполнила доставку железобетонные изделия на строительную площадку жилищного комплекса «ДЫШИ» в городе Туле. Процесс доставки был тщательно организован: каждый этап транспортировки контролировался нашими специалистами. Благодаря профессионализму и четкой работе нашей команды, материалы были доставлены в идеальном состоянии и точно в срок. Наши клиенты могут быть уверены в надежности и профессионализме нашей компании.',
            'smalltext' : 'Не упустите возможность получить бесплатную консультацию!',
        },

        {
            'image' : '29',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Траспортно-пересадочный узел РОСТОКИНО',
            'linkstext' : [
                'Фундамент Ф-1 Ф-2 Ф-3',
                'Ригеля с Р 1- по Р-37',
            ],
            'links' : [
                '',
                'https://dsk-stolica.ru/jilischnoe-stroitelstvo/rigeli-zhelezobetonnie/detali-rigelya',
            ],
            'description' : 'Наша компания завершила успешную доставку бетонных конструкций на строительный объект транспортно-пересадочного узла РОСТОКИНО. Несмотря на сложные погодные условия, все поставки были выполнены вовремя и в полном объёме. Высокое качество обслуживания – наш приоритет. Благодарим за выбор ДСК-Столицы!',
            'smalltext' : 'Сделайте заказ прямо сейчас!',
        },

        {
            'image' : '30',
            'facility' : 'Объект',
            'date' : 2021,
            'title' : 'Морской порт в Усть-Луге, Ленинградская область',
            'linkstext' : [
                'Фундаментные блоки ФБС 24-4-6',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/fundamentnie-bloki/bloki-fbs',
            ],
            'description' : 'Компания ДСК-Столица уже более 13 лет занимается поставками строительных материалов по всей России. Наши клиенты доверяют нам, потому что мы всегда выполняем свои обязательства и доставляем продукцию точно в срок. Недавно мы успешно выполнили крупный заказ для строительства морского порта в Ленинградской области. Наша компания справилась с задачей в рекордные сроки, обеспечив высокое качество продукции и соблюдение всех технических требований.',
            'smalltext' : 'Не ждите повышения цен, покупайте сейчас!',
        },

        {
            'image' : '31',
            'facility' : 'Объект',
            'date' : 2022,
            'title' : 'ТЭЦ-22, ТЭЦ-25, ТЭЦ-27, г. Москва',
            'linkstext' : [
                'Бетонный забор ПО-2',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/zabori-gbi/betonnie-zabori/po-2.html',
            ],
            'description' : 'Компания ДСК-Столица завершила крупный проект по поставке изделий для строительства тепловых электростанции в городе Москве. Мы выполнили заказ в соответствии с согласованным графиком, используя наш современный автопарк и специализированное оборудование. ДСК-Столица гордится своей репутацией надежного партнера и готов продолжать предоставлять лучшие решения для своих клиентов.',
            'smalltext' : 'Быстрый расчёт заявки! Хотите так же? Обращайтесь!',
        },

        {
            'image' : '32',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Прокладка трубопровода, Троицк Московская область',
            'linkstext' : [
                'Индивидуальная плита П1 (5300х1300мм)',
            ],
            'links' : [
                '',
            ],
            'description' : 'Поступил заказ от организации на поставку строительных материалов для прокладки трубопровода в городе Троицке. Компания ДСК-Столица оперативно приняла заказ и успешно осуществила доставку материалов точно в срок, полностью соответствуя всем требованиям заказчика. Мы стремимся к долгосрочному сотрудничеству с нашими заказчиками, предлагая гибкие условия сотрудничества и персонализированный подход к каждому проекту. Компания ДСК-Столица всегда готова к новым вызовам и уверена, что вместе мы достигнем успеха.',
            'smalltext' : 'Не ждите, пока товар закончится на складе!',
        },

        {
            'image' : '33',
            'facility' : 'Объект',
            'date' : 2024,
            'title' : 'Жилищное домостроение по реновации, г. Москва',
            'linkstext' : [
                'Марш ЛМ-150',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/lestnichnie-marshi/marshi-lm',
            ],
            'description' : 'Компания ДСК-Столица продолжает устанавливать новые стандарты в области доставки строительных материалов. Наш опытный персонал и современная техника позволяют нам оперативно реагировать на потребности наших клиентов. Наш подход к каждому проекту индивидуален, и мы гордимся тем, что способны удовлетворить потребности наших клиентов, даже в самых сложных условиях.',
            'smalltext' : 'Быстрый и точный расчёт! Хотите так же? Пишите нам!',
        },

        {
            'image' : '34',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Строительство детской школы искусств имени М. И. Глинки, г. Санкт-Петербург',
            'linkstext' : [
                'Плиты перекрытия, высота: 300мм., длина: 12м.',
            ],
            'links' : [
                'https://dsk-stolica.ru/chastnoe-domostroenie/pliti-perekritiya/pliti-perekritiya-pk',
            ],
            'description' : 'Мы, компания ДСК-Столица, с гордостью сообщаем о завершении успешного проекта по поставке строительных материалов для детской школы искусств имени М.И. Глинки в Санкт-Петербурге. С использованием современной логистической инфраструктуры, мы гарантировали сохранность и целостность материалов. Наш опыт и профессионализм помог строительным работам начаться в установленные сроки. Компания ДСК-Столица гордится успешным выполнением этой задачи и готова продолжать предлагать лучшие решения для будущих проектов наших клиентов.',
            'smalltext' : 'Не ждите повышения цен, покупайте сейчас!',
        },

        {
            'image' : '35',
            'facility' : 'Объект',
            'date' : 2022,
            'title' : 'Газовый трубопровод, Республика Коми, Вуктыл',
            'linkstext' : [
                'Фундамент индивидуальный -',
            ],
            'links' : [
                '',
            ],
            'description' : 'Уважаемые клиенты и партнёры! Мы рады сообщить о завершении успешной доставки изделий для прокладки газового трубопровода в республике Коми. Доставка прошла без задержек и проблем, благодаря слаженной работе нашей команды. Ваше доверие – наша главная ценность. Ждём новых заказов и всегда готовы помочь в реализации ваших проектов.',
            'smalltext' : 'Не упустите возможность получить бесплатную консультацию!',
        },

        {
            'image' : '36',
            'facility' : 'Объект',
            'date' : 2022,
            'title' : 'Жилищное домостроение в Иваново',
            'linkstext' : [
                'Индивидуальные фундаменты ФМ',
            ],
            'links' : [
                '',
            ],
            'description' : 'Компания ДСК-Столица осуществила поставку железобетонных изделий для нового жилищного проекта в городе Иваново. Каждая партия была тщательно проверена на соответствие спецификациям заказчика перед отправкой.Мы гордимся своей репутацией надежного партнера в сфере строительства и готовы к новым вызовам и проектам.',
            'smalltext' : 'Быстрый расчёт заявки! Хотите так же? Обращайтесь!',
        },

        {
            'image' : '37',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Сурский гидроузел КС, г. Пенза',
            'linkstext' : [
                'Кольца КС',
            ],
            'links' : [
                'https://dsk-stolica.ru/injenernoe-stroitelstvo/kolca-dlya-kolodca/kolca-ks',
            ],
            'description' : 'Недавно мы успешно выполнили заказ на поставку железобетонных изделий для строительства нового гидроузла в городе Пемзе. Все материалы были тщательно проверены на соответствие стандартам и доставлены без единого повреждения. Проект продолжается согласно графику, и мы гордимся своим вкладом в его реализацию.',
            'smalltext' : 'Не упустите возможность получить бесплатную консультацию!',
        },

        {
            'image' : '38',
            'facility' : 'Объект',
            'date' : 2023,
            'title' : 'Реконструкция Моста в центре города Орел',
            'linkstext' : [
                'Дорожные ограждения блоки Нью-джерси',
            ],
            'links' : [
                'https://dsk-stolica.ru/dorojnoe-stroitelstvo/dorozhnie-ograzhdeniya/bloki-nyu-dzhersi',
            ],
            'description' : 'Компания ДСК-Столица завершила успешную поставку строительных материалов для реконструкции моста в городе Орле. Мы доставили изделия точно в установленные сроки. Наша компания всегда нацелена на долгосрочное и взаимовыгодное сотрудничество с нашими клиентами. Каждый проект для нас – это возможность продемонстрировать нашу способность к инновациям и качественному выполнению задач.',
            'smalltext' : 'Не упустите возможность получить бесплатную консультацию!',
        },
        
    ];

   
    const ourdeliveriesContent = document.querySelector('.ourdeliveries__content');
    const ourdeliveriesBtnMore = document.querySelector('.ourdeliveries__btn');
    const cardsCount = 6;

    const renderCardNews = (obj) => {
        
        const link = obj.links.map((link, ind) => link !== ''
         ? `<a class="ourdeliveries__item-list-link ourdeliveries--link" target="_blank" href="${link}">- ${obj.linkstext[ind]}</a>`
         : `<span class="ourdeliveries__item-list-text ourdeliveries--link">- ${obj.linkstext[ind]}</span>`).join('');

        const card = `
            <div class="ourdeliveries__col ourdeliveries__col--hover">
                <div class="ourdeliveries__item">
                    <div class="ourdeliveries__item-img">
                        <img src="images/ourdeliveries/${obj.image}.jpg" alt="Картинка" width="536" height="278">
                        <img class="ourdeliveries__item-img-icon modalBtn" data-modalbtn="112" src="images/icon/icon-plus-blue.svg" alt="Плюс">
                    </div>
                    <div class="ourdeliveries__body">
                        <div class="ourdeliveries__item-top">
                            <span class="ourdeliveries__item-top-text">Объект</span>
                            <span class="ourdeliveries__item-top-date">${obj.date} г.</span>
                        </div>
                        <div class="ourdeliveries__body-content">
                            <h3 class="ourdeliveries__item-title">${obj.title}</h3>
                            <div class="ourdeliveries__item-lists">
                                <span class="ourdeliveries__item-lists-text">Продукция</span>
                                
                                ${link}

                            </div>
                        </div>
                        <div class="ourdeliveries__item-content">
                            <p class="ourdeliveries__item-content-text">
                                ${obj.description}
                            </p>
                            <div class="ourdeliveries__item-bottom">
                                <p class="ourdeliveries__item-content-text-bold">${obj.smalltext}</p>
                                <button class="ourdeliveries__item-content-btn modalBtn" type="button" data-modalbtn="10">
                                    <span>Сделать заказ</span>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 1V7M7 7V13M7 7H13M7 7L1 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        return card;
    }
    
    // При клике на кнопку показать ещё показываются ещё шесть карточек
    if (ourdeliveriesBtnMore) {
        ourdeliveriesBtnMore.addEventListener('click', () => {
            const item = news.splice(0, cardsCount);

            item.forEach(el => {
                const card = renderCardNews(el);
                ourdeliveriesContent.insertAdjacentHTML('beforeend', card);
            });

            ourdeliveriesColHover(document.querySelectorAll('.ourdeliveries__col'));
            uneversalModal();
            // Скрывает кнопку показать еще если нету что добавлять
            news.length === 0 ? ourdeliveriesBtnMore.style.display = 'none' : '';
        });
    }


    // При наведение на карточку появляется скрытный контент
    const ourdeliveriesColHover = (card) => {
        card.forEach(el => {
            
            el.addEventListener('mouseenter', () => {
                const caradHieght = el.getBoundingClientRect().height;
                const cardItem = el.querySelector('.ourdeliveries__item');
                cardItem.style.height = 'auto';
                el.style.minHeight = caradHieght + 'px';
                el.classList.add('ourdeliveries--hover');
            });
    
            el.addEventListener('mouseleave', () => {
                const cardItem = el.querySelector('.ourdeliveries__item');
                cardItem.style.height = '';
                el.style.minHeight = '';
                el.classList.remove('ourdeliveries--hover');
            });
        });
    }
    ourdeliveriesColHover(document.querySelectorAll('.ourdeliveries__col'));
    
    //begin Модальное окно по нажатию плюс на mobile и tablet
    const modalOurdeliveriesWrap = document.querySelector('.ourdeliveriesWrap');

    function ourdeliveriesModal() {
        if (ourdeliveriesContent) {
            ourdeliveriesContent.addEventListener('click', ( {target} ) => {
                const ourdeliveriesImgIcon = target.closest('.ourdeliveries__item-img-icon');
                if (!ourdeliveriesImgIcon) return;
                const cardItem = target.closest('.ourdeliveries__item');

                const cardObj = {
                    img : cardItem.querySelector('.ourdeliveries__item-img img').src,
                    title : cardItem.querySelector('.ourdeliveries__item-title').textContent,
                    links : cardItem.querySelectorAll('.ourdeliveries--link'),
                    description : cardItem.querySelector('.ourdeliveries__item-content-text').textContent,
                    text : cardItem.querySelector('.ourdeliveries__item-content-text-bold').textContent,
                };



                modalOurdeliveriesWrap.innerHTML = '';

                const modalContent = ourdeliveriesContentModal(cardObj.img, cardObj.title, cardObj.links, cardObj.description, cardObj.text);

                modalOurdeliveriesWrap.insertAdjacentHTML('beforeend', modalContent);

                // Скрывает модальное окно
                const modalBtn = modalOurdeliveriesWrap.querySelector('.ourdeliveries__item-content-btn');
                modalBtn.addEventListener('click', ( {target} ) => {
                    target.closest('.modal').classList.remove('show');
                });

                uneversalModal();
            });
        }
    }
 
    function ourdeliveriesContentModal(img, title, links, desc, text) {

        const link = Array.from(links).map(link => link.hasAttribute('href')
            ? `<a class="ourdeliveries__item-list-link ourdeliveries--link" target="_blank" href="${link.attributes[2].nodeValue}">${link.textContent}</a>` 
            : `<span class="ourdeliveries__item-list-text ourdeliveries--link">${link.textContent}</span>`).join('');

        const modalContent = `
            <div class="ourdeliveries__item">
                <div class="ourdeliveries__item-img">
                    <img src="${img}" alt="Картинка" width="536" height="278">
                </div>

                <div class="ourdeliveries__body">
                    <div class="ourdeliveries__item-top">
                        <span class="ourdeliveries__item-top-text">Объект</span>
                        <span class="ourdeliveries__item-top-date">2024 г.</span>
                    </div>
                    <div class="ourdeliveries__body-content">
                        <h3 class="ourdeliveries__item-title">${title}</h3>
                        <div class="ourdeliveries__item-lists">
                            <span class="ourdeliveries__item-lists-text">Продукция</span>
                            ${link}
                        </div>
                    </div>

                    <div class="ourdeliveries__item-content">
                        <p class="ourdeliveries__item-content-text no-wrap">${desc}</p>
                        <div class="ourdeliveries__item-bottom">
                            <p class="ourdeliveries__item-content-text-bold">${text}</p>
                            <button class="ourdeliveries__item-content-btn modalBtn" type="button" data-modalbtn="10">
                                <span>Сделать заказ</span>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 1V7M7 7V13M7 7H13M7 7L1 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </div>
                    </div> 
                </div>
            </div>
        `;

        return modalContent;
    }
    ourdeliveriesModal();
    //end Модальное окно по нажатию плюс на mobile и tablet
    // end Секция Наши доставки

    // begin Секция достижения
    let playFun = true;
    const runningNumber = (selector, numTime, numStep, num) => {
        const achievementsNumber = document.querySelector(selector);
        let n = 0;
        let t = Math.round(numTime / (num / numStep));
        let interval = setInterval(() => {
            n = n + numStep;
            if (n == num) clearInterval(interval);
            if (achievementsNumber) {
                achievementsNumber.textContent = n.toLocaleString();
            }

        }, t);
    };

    window.addEventListener('scroll', () => {
        const sectionAchievements = document.querySelector('.section-achievements');
        if (sectionAchievements) {
            const rect = sectionAchievements.getBoundingClientRect();

            if (Math.round(rect.top + 700) <= window.innerHeight) {
                if (playFun) {
                    playFun = false;
                    runningNumber('.number1', 1200, 100, 7400);
                    runningNumber('.number2', 1200, 500, 120500);
                    runningNumber('.number3', 1200, 10, 500);
                    runningNumber('.number4', 1200, 500, 100000);
                    runningNumber('.number5', 1200, 280, 3080);
                }
            }
        }

    });
    // end Секция достижения





    // begin Модальное окно с видео + двигающая дорожка
    const uschooseWrap = document.querySelector('.uschoose__wrap');
    if (uschooseWrap) {
        const uschooseItems = Array.from(document.querySelectorAll('.uschoose__item'));
        const uschooseItemsWidth = Array.from(document.querySelectorAll('.uschoose__item-width'));
        const modalVideo = document.querySelector('.modal-video');
        const modalPosition = document.querySelector('.modal-position');
        const modalVideoIconplay = document.querySelector('.modal__video-iconplay');
        let uschooseWrapWidth = 0;

        const modalBtnNext = document.querySelector('.modal_btn-next');
        const modalBtnPrev = document.querySelector('.modal_btn-prev');

        let cardObj = {};
        // begin Узнаем ширину секции с видео
        // Ширина блока карточки составляет 212px + отступ 34px = 246px.
        // Мы хотим показать 22 блока. 22*246=5412px ширина Блока
        uschooseWrapWidth = (uschooseItemsWidth[0].getBoundingClientRect().width + 34) * uschooseItemsWidth.length;
        uschooseWrap.style.width = `${uschooseWrapWidth}px`;
        // end Узнаем ширину секции с видео


        uschooseItems.forEach((card, ind) => {
            card.addEventListener('click', ( {target} ) => {
                if (target.closest('.uschoose__slider-iconplay')) {

                    cardObj = {
                        cardIndex: ind,
                        cardDataPoster: card.dataset.poster,
                        cardDatavideo: card.dataset.video,
                        cardText: card.querySelector('.uschoose__desc p').textContent,
                    }

                    createVideo(cardObj.cardDataPoster, cardObj.cardDatavideo, cardObj.cardText);
                    modalVideoIconplay.style.display = 'block';
                    uschooseWrap.style.animationPlayState = 'paused';
                }
            });
        });

        const createVideo = (numberPoster, numberVideo, text) => {
            const video = document.createElement('video');
            const source = document.createElement('source');
            const modaText = modalVideo.querySelector('.modal__video-desc');

            video.classList.add('modal__video-content-video');
            video.setAttribute('poster', `./video/video_company/modalposter${numberPoster}.jpg`);
            source.setAttribute('src', `./video/video_company/video${numberVideo}.mp4`);
            source.setAttribute('type', 'video/mp4');

            video.append(source);
            modaText.textContent = text;
            modalPosition.firstElementChild.after(video);
        }

        modalVideo.addEventListener('click', ( {target} ) => {
            const close = target.closest('.modal__video-close');

            if (close) {
                modalVideo.querySelector('.modal__video-content-video').remove();
                uschooseWrap.style.animationPlayState = '';
            }

            if (!target.closest('.modal__video-center')) {
                modalVideo.querySelector('.modal__video-content-video').remove();
                uschooseWrap.style.animationPlayState = '';
                target.closest('.modal').classList.remove('show');
                overlow.classList.remove('overlow--active');
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
                document.querySelector('.header__production').style.paddingRight = '';

            }
        });

        modalVideoIconplay.addEventListener('click', () => {
            const videoPlay = modalVideo.querySelector('.modal__video-content-video');
            videoPlay.setAttribute('controls', '');
            videoPlay.play();
            modalVideoIconplay.style.display = 'none';
        });

        modalBtnNext.addEventListener('click', () => {
            const videoPlay = modalVideo.querySelector('.modal__video-content-video');
            modalVideoIconplay.style.display = 'block';

            cardObj.cardIndex++;
            videoPlay.remove();

            if (cardObj.cardIndex > uschooseItemsWidth.length - 1) {
                cardObj.cardIndex = 0;
            }

            cardObj.cardDataPoster = uschooseItemsWidth[cardObj.cardIndex].dataset.poster;
            cardObj.cardDatavideo = uschooseItemsWidth[cardObj.cardIndex].dataset.video;
            cardObj.cardText = uschooseItemsWidth[cardObj.cardIndex].querySelector('.uschoose__desc p').textContent;

            createVideo(cardObj.cardDataPoster, cardObj.cardDatavideo, cardObj.cardText);
        });

        modalBtnPrev.addEventListener('click', () => {
            const videoPlay = modalVideo.querySelector('.modal__video-content-video');
            modalVideoIconplay.style.display = 'block';
            cardObj.cardIndex--;
            videoPlay.remove();

            if (cardObj.cardIndex <= 0) {
                cardObj.cardIndex = uschooseItemsWidth.length - 1;
            }

            cardObj.cardDataPoster = uschooseItemsWidth[cardObj.cardIndex].dataset.poster;
            cardObj.cardDatavideo = uschooseItemsWidth[cardObj.cardIndex].dataset.video;
            cardObj.cardText = uschooseItemsWidth[cardObj.cardIndex].querySelector('.uschoose__desc p').textContent;

            createVideo(cardObj.cardDataPoster, cardObj.cardDatavideo, cardObj.cardText);
        });

    }
    // end стр. о Компании Модальное окно с видео
    // end стр. о Компании






    // begin модальное окно свяжитесь со мной
    const modalContactMe = document.getElementById('modalContactMe');

    if (modalContactMe) {

        // Взаимодействия с модальным окном
        const btnOpenModal = () => {
            const btnModal = document.querySelectorAll('.companyteam__btn');

            btnModal.forEach(btn => {
                btn.addEventListener('click', ( {target} ) => {
                    const dataModal = +btn.dataset.modalbtn;

                    const modalImgWrap = modalContactMe.querySelector('.modalContact__image');
                    const modalName = modalContactMe.querySelector('.modalContact__content-name');
                    const modalText = modalContactMe.querySelector('.modalContact__content-text');
                    let modalEmailHidden = modalContactMe.querySelector('.modalContact__email-hidden');

                    if (dataModal == 222) {
                        const cards = target.closest('.companyteam__item');

                        const infoObj = {
                            img: cards.dataset.imgSmall,
                            name: cards.querySelector('.companyteam__name').textContent,
                            text: cards.querySelector('.companyteam__text').textContent,
                            email: cards.dataset.email,
                        };

                        modalEmailHidden.value = infoObj.email;

                        modalImgWrap.innerHTML = ''
                        const modalImg = document.createElement('img');
                        modalImg.setAttribute('src', `../images/production/company/companyteam/${infoObj.img}.png`);
                        modalImg.setAttribute('alt', infoObj.name);
                        modalImg.setAttribute('widht', 59);
                        modalImg.setAttribute('height', 59);

                        modalImgWrap.append(modalImg);
                        modalName.textContent = infoObj.name;
                        modalText.textContent = infoObj.text;
                    }
                });
            });
        }
        btnOpenModal();
        // Взаимодействия с модальным окном

        // Переключения Телефон/Почта
        const textTab = modalContactMe.querySelectorAll('.modalContact__tabs-top-text');
        const inputTab = modalContactMe.querySelectorAll('.modalContact__tab');
        for (let i = 0; i < textTab.length; i++) {
            textTab[i].addEventListener('click', () => {
                for (let j = 0; j < textTab.length; j++) {
                    textTab[j].classList.remove('active');
                    inputTab[j].classList.remove('active');
                }
                textTab[i].classList.add('active');
                inputTab[i].classList.add('active');
            });
        }
        // Переключения Телефон/Почта
    }
    // end модальное окно свяжитесь со мной

});